// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_OH3","cls2":"Comments-cls2__FR Comments-cls1_OH3"};